/**
 * debounce (event grouping)
 * @param {function} callback - debounce 적용 할 function
 * @param {number} limit - 제한시간
 * @param {boolean} leading - event 적용 위치 (default - true (이벤트 시작시))
 * @returns {function} debounce 적용 된 function
 */
function debounce(callback, limit = 300, leading = true) {
  let timeout
  return function (...args) {
    const immediate = leading && !timeout

    const execute = () => {
      timeout = null
      if (!leading) {
        callback.apply(this, args)
      }
    }

    clearTimeout(timeout)
    timeout = setTimeout(execute, limit)

    if (immediate) {
      callback.apply(this, args)
    }
  }
}

/**
 * throttle (set event period)
 * @param {*} callback 
 * @param {*} limit - 제한시간
 * @returns throttle 적용 된 function
 */
function throttle(callback, limit = 200) {
  let waiting = false
  return function () {
    if (!waiting) {
      callback.apply(this, arguments)
      waiting = true
      setTimeout(() => {
        waiting = false
      }, limit)
    }
  }
}

export {
  debounce,
  throttle
}